<template>
  <nav-bar
    :inSession="inSession"
    :title="
      
      $route.name
    "
  />
</template>

<script>
import NavBar from "./NavBar.vue";

import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  components: {
    NavBar,
  },
  data() {
    return {
      phoneDraw: false,
      inSession: false,

      userPermissions: [],
      userNavigations: [],
    };
  },
  methods: {
    ...mapActions([
      "autoLogin",
      "SetMessageDialog",
      // "ShowProgressBar",
      "logout",
    ]),
    ...mapMutations(["setIsPhoneDrawn"]),
    filteredNavigation() {
      this.userNavigations = this.navigationsMenu.filter((menu) => {
        if (this.userPermissions.includes(menu.permission)) {
          return menu;
        }
      });
    },
    matchPermission(domainPlugins) {
      let userMatched = [];
      domainPlugins.forEach((plugin) => {
        if (this.userPermissions.includes(plugin.permission)) {
          userMatched.push(plugin);
        }
      });
      return userMatched;
    },
    sessionConnect(status) {
      this.inSession = status;
    },
    initHeader() {
      this.userPermissions = this.permissions;
      this.filteredNavigation();
    },
  },
  computed: {
    ...mapGetters([
      "uname",
      "fullname",
      "permissions",
      "domain",
      "plugings",
      "workPlace",
      "usePhone",
      "getPages",
      "getSections",
      "phonePermission",
      "navigationsMenu",
      "logos",
      "numberToCall",
    ]),
    userTitle() {
      return this.uname + "/" + this.fullname;
    },

    // mdAndUp() {
    //   return this.$vuetify.display.mdAndUp;
    // },
    // mdAndDown() {
    //   return this.$vuetify.display.mdAndDown;
    // },
    currentLocal() {
      return this.$vuetify.locale.current;
    },
    hasPhonePermission() {
      return (
        this.usePhone && this.userPermissions.includes(this.phonePermission)
      );
    },
    Logo() {
      return this.logos ? JSON.parse(this.logos).menu_logo : "";
    },
  },
  async mounted() {
    if (this.domain) {
      this.initHeader();
    } else {
      try {
        var resp = await this.autoLogin();
        // this.ShowProgressBar({ show: false, message: "" });
        if (resp.success) {
          this.initHeader();
        } else {
          this.SetMessageDialog({ show: true, message: resp.message });
        }
      } catch (error) {
        if (error.response.status === 401) {
          await this.logout();
        } else {
          let message = error.message;
          if (error.response) {
            message = error.response.data.message;
          }
          this.SetMessageDialog({ show: true, message: message });
        }
      }
    }
  },
  watch: {
    phoneDraw(value) {
      this.setIsPhoneDrawn(value);
    },
    numberToCall(val) {
      console.log("My number to call is set in header", val);
      if (val && val != "" && val?.length > 0) {
        this.phoneDraw = true;
      }
    },
  },
};
//  // "middlewareURL": "http://51.89.201.218/middleware"
</script>
<style>
/* .v-list-item-title {
  font-size: 20px;
} */
/* .v-list-item .v-list-item--link .v-list-item--nav {
  white-space: initial !important;
}
.v-list-item--nav {
  padding-inline-end: 0px !important;
} */
.wrap-text {
  white-space: normal !important;
}
div.v-list-item-title {
  white-space: normal !important;
}
/* .nav-item-style .v-list-item {
  min-height: 15 !important;
  white-space: normal !important;
} */

.nav-item-style .v-list-item-title {
  font-size: 0.9rem !important;
  line-height: 1.5rem !important;
  white-space: initial !important;
}

.nav-logo-style .v-list-item--nav .v-list-item-title {
  font-size: 1.2rem !important;
  line-height: 2rem;
  height: 50px;
}

.letters {
  color: #18ffff;
  font-size: 40px;
  font-family: "Sacramento";
}
.first {
  background-clip: text;
  animation-name: shine;
  animation-duration: 3s;
  /* animation-fill-mode: ease-in-out */
  float: left;
  /* animation-iteration-count: infinite; */
}

@keyframes shine {
  100% {
    transform: translatex(0px) translatey(0px);
  }
  0% {
    transform: translatex(50px) translatey(50px);
  }
}
.second {
  background-clip: text;
  animation-name: rest;
  animation-duration: 4s;
  float: left;
}
@keyframes rest {
  100% {
    transform: translatex(0px) translatey(0px);
  }
  0% {
    transform: translatex(100px);
  }
}
.third {
  background-clip: text;
  animation-name: set;
  animation-duration: 4s;
  font-size: 30px;
  float: left;
}
@keyframes set {
  100% {
    transform: translatex(0px) translatey(0px);
  }
  0% {
    transform: translatex(-100px);
  }
}
/* .gradient-custom-en .v-toolbar__content {
  background: #1de9b6 !important;
  height: 30px;

  background: -webkit-linear-gradient(to right, #1de9b6, #00897b) !important;

  background: linear-gradient(to right, #1de9b6, #00897b) !important;
}
.gradient-custom-ar .v-toolbar__content {
  background: #00897b !important;
  height: 30px;

  background: -webkit-linear-gradient(to right, #00897b, #1de9b6) !important;

  background: linear-gradient(to right, #00897b, #1de9b6) !important;
} */
</style>
